"use strict";
/**
 * @module Services.GatewayControl
 */
Object.defineProperty(exports, "__esModule", { value: true });
var gateway_request_type_1 = require("./../../services/gateway-control/gateway-request-type");
/**
 * Gateway response from a get service types request.
 */
var GetServiceTypesResponse = /** @class */ (function () {
    /**
     * Create a new GetOperationsResponse instance
     *
     * @param serviceTypes the service types
     */
    function GetServiceTypesResponse(serviceTypes) {
        /**
         * Required for round-trip serialiser tests.
         */
        this.type = gateway_request_type_1.GatewayRequestType.GET_SERVICE_TYPES;
        this.serviceTypes = serviceTypes;
    }
    return GetServiceTypesResponse;
}());
exports.GetServiceTypesResponse = GetServiceTypesResponse;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/get-service-types-response.js
// module id = 1330
// module chunks = 1